<ion-footer collapse="fade">
  <ion-grid>
    <ion-row>
      <ion-col size="12" size-md="6">
        <div class="mt-2 flex ion-justify-content-center">
          <a class="mr-2" href="https://www.toro.com/en-us/pages/legal/terms-of-use.aspx" target="_blank">Terms of
            Use</a>
          | <a class="ml-2" href="https://www.toro.com/en-us/pages/legal/privacy-policy.aspx" target="_blank">Privacy
            Policy</a>
        </div>
        <div class="mt-3 ion-text-center">
          Copyright {{this.currentYear}} The Toro Company. All Rights Reserved
        </div>
      </ion-col>
      <ion-col size="12" size-md="6">
        <div class="flex ion-justify-content-center">
          <ion-button size="small" fill="clear" (click)="this.launchAboutModal()">About AquaFlow</ion-button>
        </div>
        <div class="flex ion-justify-content-center">
          <a class="mr-2" href="https://www.toro.com" target="_blank">toro.com</a>
          | <a class="ml-2" href="https://driptips.toro.com" target="_blank">driptips.toro.com</a>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
